import { asArray } from "ol/color";
import VectorTileLayer from "ol/layer/VectorTile";
import WebGLVectorTileLayerRenderer from "ol/renderer/webgl/VectorTileLayer";
import {packColor, parseLiteralStyle} from 'ol/webgl/styleparser.js';

const result:any = parseLiteralStyle({
  'fill-color': ['get', 'fillColor'],
  'stroke-color': ['get', 'strokeColor'],
  'stroke-width': ['get', 'strokeWidth'],
  'circle-radius': ['get', 'size'],
  'circle-fill-color': ['get', 'fillColor'],
});


export default class WebGLVectorTileLayer extends VectorTileLayer {
    public mapservice?:any;

    createRenderer():any {
      let self:any=this;
      return new WebGLVectorTileLayerRenderer(self, {
        style: {
          builder: result.builder,
          attributes: {
            fillColor: {
              size: 2,
              callback: (feature) => {
                let s=self.getStyle()(feature, self.mapservice.view.getResolution());
                if(s){
                  const style = Array.isArray(s)? s[0]:s;
                  const color = asArray(style?.getFill()?.getColor() || '#eee');
                  return packColor(color);
                }
                else{
                  console.log("error for :"+feature)
                  return packColor('#eee');
                }
                
              },
            },
            strokeColor: {
              size: 2,
              callback: (feature) => {
                let s=self.getStyle()(feature, self.mapservice.view.getResolution());
                if(s){
                  const style = Array.isArray(s)? s[0]:s;
                  const color = asArray(style?.getStroke()?.getColor() || '#eee');
                  return packColor(color);
                }
                else{
                  console.log("error for :"+feature)
                  return packColor('#eee');
                }
              },
            },
            strokeWidth: {
              size: 1,
              callback: (feature) => {
                let s=self.getStyle()(feature, self.mapservice.view.getResolution());
                if(s){
                  const style = Array.isArray(s)? s[0]:s;
                  return style?.getStroke()?.getWidth() || 0;
                }
                else{
                  console.log("error for :"+feature)
                  return 0;
                }
              },
            },
            size: {
              size: 1,
              callback: (feature) => {
                let s=self.getStyle()(feature, self.mapservice.view.getResolution());
                if(s){
                  const style = Array.isArray(s)? s[0]:s;
                  if(style?.getImage()!=null){
                    return style?.getImage().getRadius();
                  }else{
                    return 0;
                  }
                  
                }
                else{
                  console.log("error for :"+feature)
                  return 0;
                }
              },
            },
          },
        },
      });
    }
  }
